import { createActions, createReducer } from "reduxsauce";
import { call, put, all, takeEvery } from "redux-saga/effects";
import { axiosCall } from "../helpers/funtioncs";
import { Creators as creatorsConfig } from "../ducks/config";

const apiPetcozoo_baseUrl = process.env.REACT_APP_API_PETCOZOO;

/* --------Sagas-----------*/
function* getAllProvidersSaga({ token }) {
  try {
    const allProviders = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/providers/getAllProviders`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    // console.log(allProviders, "aquí proveedores");
    yield put(Creators.getAllProvidersSuccess(allProviders.data));
  } catch (error) {
    console.error("Error fetching providers:", error);
    yield put(Creators.failProviders());
  }
}

function* getProviderByIdSaga({ token, idUser }) {
  try {
    const provider = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/providers/getProviderById/${idUser}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    // console.log(provider.data, "estos")
    yield put(Creators.getProvidersSuccess([provider.data]));
  } catch (error) {
    console.error("Error fetching Stores:", error);
    yield put(Creators.failProviders());
  }
}

function* updateStockSaga({ token, providerId, newStock }) {
  try {
    const provider = yield call(axiosCall, {
      method: "put",
      url: `${apiPetcozoo_baseUrl}/providers/updateStock/${providerId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        newStock: newStock,
      },
    });

    yield all([
      yield put(Creators.updateStockSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Inventario actualizado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    //console.log(error);
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* createMaterialSaga({
  token,
  providerId,
  material,
  clusters,
  nombreCientifico,
  file,
  selectedGuia,
}) {
  try {
    const formData = new FormData();
    formData.append("providerId", providerId);
    formData.append("materialObj", JSON.stringify(material)); // lo mandas string
    formData.append("clusters", JSON.stringify(clusters)); // si es array u objeto
    formData.append("nombreCientifico", nombreCientifico);
    if (file) {
      formData.append("file", file);
    }
    if (selectedGuia) {
      formData.append("selectedGuia", selectedGuia);
    }
    const provider = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/providers/addmaterial`,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: token,
      },
      data: formData,
    });

    yield all([
      yield put(Creators.createMaterialSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Material Creado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    console.log(error, "error yield1");
    /*const message =
      error.response && error.response.data !== null && error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";*/
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Ocurrió un error";

    console.log(message, "error yield");
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* addMatProviderSaga({ token, providerId, material, clusters }) {
  try {
    const provider = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/providers/addmaterialprovider/${providerId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        material,
        clusters,
      },
    });

    yield all([
      yield put(Creators.addMatProviderSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Material Agregado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    console.log(error, "error yield1");
    const message =
      error.response && error.response.data !== null && error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    console.log(message, "error yield");
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* updateMaterialSaga({ token, providerId, material, idMaterial }) {
  console.log("idsote2", idMaterial);
  try {
    const provider = yield call(axiosCall, {
      method: "patch",
      url: `${apiPetcozoo_baseUrl}/providers/updatematerial/${providerId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        idMaterial,
        material,
      },
    });

    yield all([
      yield put(Creators.updateMaterialSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Material actualizado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    // console.log(error, "error yield");
    const message =
      error.response && error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    console.log(message, "error yield");
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* deleteMaterialSaga({ token, providerId, idMaterial }) {
  try {
    const provider = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/providers/deletematerial`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        providerId,
        idMaterial,
      },
    });

    yield all([
      yield put(Creators.deleteMaterialSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Material eliminado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    // console.log(error, "error yield");
    const message =
      error.response && error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    console.log(message, "error yield");
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* createProviderSaga({ token, newProvider }) {
  try {
    const provider = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/providers/createProvider`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: newProvider,
    });

    yield all([
      yield put(Creators.createProviderSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Proveedor agregado`,
          type: "success",
        })
      ),
    ]);
    yield put(Creators.getAllProviders(token));
  } catch (error) {
    console.log("error1", error);
    // console.log(error, "error yield");
    const message =
      error.response && error.response !== null
        ? error.response.data.message || error.response.data.replyText
        : "Ocurrio un error";
    console.log(message, "error yield");
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* desactiveProviderSaga({ token, idNumber }) {
  try {
    const provider = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/providers/desactiveProvider`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        idNumber,
      },
    });

    yield all([
      yield put(Creators.desactiveProviderSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Proveedor eliminado`,
          type: "success",
        })
      ),
    ]);
    yield put(Creators.getAllProviders(token));
  } catch (error) {
    // console.log(error, "error yield");
    const message =
      error.response && error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    console.log(message, "error yield");
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* updateProviderByIdSaga({ token, providerId, inventory }) {
  try {
    const provider = yield call(axiosCall, {
      method: "put",
      url: `${apiPetcozoo_baseUrl}/providers/updateProviderById/${providerId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        inventory: inventory,
      },
    });

    yield all([
      yield put(Creators.updateStockSuccess([provider.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Inventario actualizado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    //console.log(error);
    const message =
      error.response !== null ? error.response.data.error : "Ocurrio un error";
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* downloadInventoryProvidersSaga({ token, week }) {
  try {
    const urlDownload = week
      ? `${apiPetcozoo_baseUrl}/providers/downloadInventoryCSV/${week}`
      : `${apiPetcozoo_baseUrl}/providers/downloadInventoryCSV`;

    const downloadResponse = yield call(axiosCall, {
      method: "get",
      url: urlDownload,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      responseType: "blob",
    });

    const blob = new Blob([downloadResponse.data], { type: "text/csv" });
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const formattedDate = `${day}-${month}-${year}`;

    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute(
      "download",
      "InventarioProveedores_" + formattedDate + ".csv"
    );
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    yield all([
      yield put(Creators.downloadInventoryProvidersSuccess()),
      yield put(
        creatorsConfig.message({
          text: `Se descargó inventario proveedor`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    const message =
      error.response !== null ? error.response.data.error : "Ocurrio un error";
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* downloadInventoryByProviderSaga({ token, providerId }) {
  try {
    const urlDownload = `${apiPetcozoo_baseUrl}/providers/downloadInventoryCSVbyProvider/${providerId}`;
    const downloadResponse = yield call(axiosCall, {
      method: "get",
      url: urlDownload,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      responseType: "blob",
    });

    const blob = new Blob([downloadResponse.data], { type: "text/csv" });
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const formattedDate = `${day}_${month}_${year}`;

    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute(
      "download",
      `InventarioProveedor_${providerId}_${formattedDate}.csv`
    );
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    yield all([
      yield put(Creators.downloadInventoryProvidersSuccess()),
      yield put(
        creatorsConfig.message({
          text: `Se descargó inventario proveedor`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    const message =
      error.response !== null ? error.response.data.error : "Ocurrio un error";
    yield all([
      yield put(Creators.failProviders()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

export default function* providers() {
  yield all([
    takeEvery(Types.GET_ALL_PROVIDERS, getAllProvidersSaga),
    takeEvery(Types.GET_PROVIDER_BY_ID, getProviderByIdSaga),
    takeEvery(Types.UPDATE_STOCK, updateStockSaga),
    takeEvery(Types.UPDATE_PROVIDER_BY_ID, updateProviderByIdSaga),
    takeEvery(
      Types.DOWNLOAD_INVENTORY_PROVIDERS,
      downloadInventoryProvidersSaga
    ),
    takeEvery(
      Types.DOWNLOAD_INVENTORY_BY_PROVIDER,
      downloadInventoryByProviderSaga
    ),
    takeEvery(Types.UPDATE_MATERIAL, updateMaterialSaga),
    takeEvery(Types.CREATE_MATERIAL, createMaterialSaga),
    takeEvery(Types.ADD_MAT_PROVIDER, addMatProviderSaga),
    takeEvery(Types.DELETE_MATERIAL, deleteMaterialSaga),
    takeEvery(Types.CREATE_PROVIDER, createProviderSaga),
    takeEvery(Types.DESACTIVE_PROVIDER, desactiveProviderSaga),
  ]);
}

/*-----------Action types & creators-------------*/
export const { Types, Creators } = createActions({
  getAllProviders: ["token"],
  getProviderById: ["token", "idUser"],
  getProvidersSuccess: ["providers"],
  getAllProvidersSuccess: ["providers"],
  updateStock: ["token", "providerId", "newStock"],
  updateProviderById: ["token", "providerId", "inventory"],
  updateStockSuccess: ["newStock"],
  updateMaterialSuccess: ["newMaterial"],
  downloadInventoryProviders: ["token", "week"],
  downloadInventoryByProvider: ["token", "providerId"],
  downloadInventoryProvidersSuccess: null,
  clearAllProviders: null,
  failProviders: null,
  updateMaterial: ["token", "providerId", "material", "idMaterial"],
  createMaterial: [
    "token",
    "providerId",
    "material",
    "clusters",
    "nombreCientifico",
    "file",
    "selectedGuia",
  ],
  createMaterialSuccess: ["newMaterial"],
  addMatProvider: ["token", "providerId", "material", "clusters"],
  addMatProviderSuccess: ["newMaterial"],

  deleteMaterial: ["token", "providerId", "idMaterial"],
  deleteMaterialSuccess: ["newMaterial"],

  createProvider: ["token", "newProvider"],
  createProviderSuccess: ["newProvider"],
  desactiveProvider: ["token", "idNumber"],
  desactiveProviderSuccess: ["provider"],
});

/*------------Reducers-----------*/
const INITIAL_STATE = {
  providers: [],
  loading: false,
};

const getAllProviders = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getProviderById = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getProvidersSuccess = (state = INITIAL_STATE, { providers }) => {
  return {
    ...state,
    loading: false,
    providers: providers,
  };
};
const getAllProvidersSuccess = (state = INITIAL_STATE, { providers }) => {
  return {
    ...state,
    loading: false,
    providers: providers,
  };
};

const updateStock = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const updateProviderById = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const updateStockSuccess = (state = INITIAL_STATE, { newStock }) => {
  return {
    ...state,
    loading: false,
    providers: newStock,
  };
};

const updateMaterial = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const updateMaterialSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});
const createMaterial = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const createMaterialSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});
const addMatProvider = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const addMatProviderSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});
const deleteMaterial = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const deleteMaterialSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});
const createProvider = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const createProviderSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});
const desactiveProvider = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const desactiveProviderSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});

const downloadInventoryProviders = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const downloadInventoryByProvider = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const downloadInventoryProvidersSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});

const clearAllProviders = (state = INITIAL_STATE) => ({
  ...state,
  providers: [],
  loading: false,
});

const failProviders = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});

const HANDLERS = {
  [Types.GET_ALL_PROVIDERS]: getAllProviders,
  [Types.GET_PROVIDER_BY_ID]: getProviderById,
  [Types.GET_PROVIDERS_SUCCESS]: getProvidersSuccess,
  [Types.GET_ALL_PROVIDERS_SUCCESS]: getAllProvidersSuccess,
  [Types.UPDATE_STOCK]: updateStock,
  [Types.UPDATE_STOCK_SUCCESS]: updateStockSuccess,
  [Types.UPDATE_PROVIDER_BY_ID]: updateProviderById,
  [Types.DOWNLOAD_INVENTORY_PROVIDERS]: downloadInventoryProviders,
  [Types.DOWNLOAD_INVENTORY_BY_PROVIDER]: downloadInventoryByProvider,
  [Types.DOWNLOAD_INVENTORY_PROVIDERS_SUCCESS]:
    downloadInventoryProvidersSuccess,
  [Types.CLEAR_ALL_PROVIDERS]: clearAllProviders,
  [Types.FAIL_PROVIDERS]: failProviders,
  [Types.UPDATE_MATERIAL]: updateMaterial,
  [Types.UPDATE_MATERIAL_SUCCESS]: updateMaterialSuccess,
  [Types.CREATE_MATERIAL]: createMaterial,
  [Types.CREATE_MATERIAL_SUCCESS]: createMaterialSuccess,
  [Types.ADD_MAT_PROVIDER]: addMatProvider,
  [Types.ADD_MAT_PROVIDER_SUCCESS]: addMatProviderSuccess,
  [Types.DELETE_MATERIAL]: deleteMaterial,
  [Types.DELETE_MATERIAL_SUCCESS]: deleteMaterialSuccess,
  [Types.CREATE_PROVIDER]: createProvider,
  [Types.CREATE_PROVIDER_SUCCESS]: createProviderSuccess,
  [Types.DESACTIVE_PROVIDER]: desactiveProvider,
  [Types.DESACTIVE_PROVIDER_SUCCESS]: desactiveProviderSuccess,
};

export const reducersProviders = createReducer(INITIAL_STATE, HANDLERS);
